import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {Router, ActivatedRoute} from "@angular/router";
import {AlertService, AuthService, UsersService} from "../../../services";
import {FormGroup, FormBuilder, Validators, FormControl} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {ValidationService} from "../../../services/validation.service";
import * as Raven from "raven-js";
import {HelperService} from "../../../services/helperService";

declare let hsimp:any;

@Component({
	selector: "tig-reset",
	templateUrl: "reset.component.html",
	styleUrls: ["./reset.component.css"],
})
export class ResetComponent implements OnInit, AfterViewInit
{

	@ViewChild('password', {static: false}) OBJ_password_box: ElementRef;
	@ViewChild('checks',{static: false}) OBJ_checks: ElementRef;

	/**
	 * Attributes
	 */
	OBJ_model: any = {};
	BOO_loading = false;
	STR_company: string;
	OBJ_form_group: FormGroup;
	STR_token: string;
	OBJ_view: {show_form: boolean, error: boolean, message: string} = { show_form: true, error: false, message: "" };


	/**
	 * Function > constructor
	 * @param {ActivatedRoute} OBJ_activated_route
	 * @param {Router} OBJ_router
	 * @param {AuthService} OBJ_auth_service
	 * @param {AlertService} OBJ_alert_service
	 * @param {FormBuilder} OBJ_form_builder
	 * @param {TranslateService} OBJ_translate_service
	 * @param {UsersService} OBJ_user_service
	 * @param {HelperService} OBJ_helper_service
	 */
	constructor
	(
		private OBJ_activated_route: ActivatedRoute,
		private OBJ_router: Router,
		private OBJ_auth_service: AuthService,
		private OBJ_alert_service: AlertService,
		private OBJ_form_builder: FormBuilder,
		private OBJ_translate_service: TranslateService,
		private OBJ_user_service: UsersService,
		private OBJ_helper_service: HelperService
	)
	{

        // get company string
        let OBJ_config = this.OBJ_helper_service.getFromLocalstorage('config');
        this.STR_company = OBJ_config.company;

		this.OBJ_form_group = OBJ_form_builder.group({
			password: new FormControl('', {
				validators: [Validators.required, ValidationService.checkPassword],
				updateOn: 'change'
			}),
			password_confirm: ["", [Validators.required, Validators.minLength(2)]]
		},{
			validator: ValidationService.matchPassword // your validation method
		});

	} // end function constructor

	/**
	 * Function > ngOnInit
	 * @return {void}
	 */
	ngOnInit(): void
	{

		// reset login status
		this.OBJ_auth_service.logout();

		// get token from url
		this.OBJ_activated_route.params.subscribe(ARR_params => {
			this.STR_token = ARR_params["token"];
		});

	} // end function ngOnInit

	ngAfterViewInit() {
		let checksList = this.OBJ_checks.nativeElement;
		let renderChecks = function (checks, input) {
			checksList.innerHTML = "";

			for (let i = 0, l = checks.length; i < l; i++) {
				let li = document.createElement("li"),
					title = document.createElement("h5"),
					message = document.createElement("p");

				title.innerHTML = checks[i].name;
				li.appendChild(title);

				message.innerHTML = checks[i].message;
				li.appendChild(message);

				checksList.appendChild(li);
			}
		};

		hsimp({
			options: {
				calculationsPerSecond: 10e9, // 10 billion calculations per second
				good: 31557600e9, // 1 billion years
				ok: 31557600e3 // 1 thousand years
			},
			outputChecks: renderChecks
		}, this.OBJ_password_box.nativeElement);
	}

	/**
	 * Function > onSubmit
	 * @desc login a user
	 * @return {void}
	 */
	onSubmit()
	{

		// valid form an token exists
		if (this.OBJ_form_group.valid && this.STR_token.length > 0)
		{

			this.OBJ_model = this.OBJ_form_group.getRawValue();
			this.BOO_loading = true;

			let OBJ_data = {
				token: this.STR_token,
				password: this.OBJ_model.password,
			};

			this.OBJ_user_service.changePassword(window.location.origin + "/api/password", OBJ_data)
			.subscribe
			(
				// login successful
				OBJ_data => {
					this.OBJ_view.show_form = false;
					this.OBJ_view.message = "oPassword.sChangedSuccessfully";
				},
				// error
				OBJ_error => {
					// Send error to Bug Tracking System
					Raven.captureException(OBJ_error);

					this.OBJ_view.show_form = false;
					this.OBJ_view.error = true;
					this.OBJ_view.message = "oPassword.sChangeError";
				}
			);

		} // end if

	} // end function onSubmit

	/**
	 * Function > showPassword
	 * @param {any} OBJ_input
	 * @return {any}
	 */
	showPassword(OBJ_input: any): any
	{
		OBJ_input.type = (OBJ_input.type==="password")?"text":"password";
	} // end class showPassword


} // end class ResetComponent
